export const ITEMS_HAVE_ERROR = "ITEMS_HAVE_ERROR";
export const ITEMS_ARE_LOADING = "ITEMS_ARE_LOADING";
export const ITEMS_FETCH_DATA_SUCCESS = "ITEMS_FETCH_DATA_SUCCESS";

export const ITEMS_MENU_HAVE_ERROR = "ITEMS_MENU_HAVE_ERROR";
export const ITEMS_MENU_ARE_LOADING = "ITEMS_MENU_ARE_LOADING";
export const ITEMS_MENU_FETCH_DATA_SUCCESS = "ITEMS_MENU_FETCH_DATA_SUCCESS";

export const LOGIN_HAVE_ERROR = "LOGIN_HAVE_ERROR";
export const LOGIN_ARE_LOADING = "LOGIN_ARE_LOADING";
export const LOGIN_FETCH_DATA_SUCCESS = "LOGIN_FETCH_DATA_SUCCESS";

export const FOOTER_HAVE_ERROR = "FOOTER_HAVE_ERROR";
export const FOOTER_ARE_LOADING = "FOOTER_ARE_LOADING";
export const FOOTER_FETCH_DATA_SUCCESS = "FOOTER_FETCH_DATA_SUCCESS";

export const PAGE_HAVE_ERROR = "PAGE_HAVE_ERROR";
export const PAGE_ARE_LOADING = "PAGE_ARE_LOADING";
export const PAGE_FETCH_DATA_SUCCESS = "PAGE_FETCH_DATA_SUCCESS";

export const INVREL_HAVE_ERROR = "INVREL_HAVE_ERROR";
export const INVREL_ARE_LOADING = "INVREL_ARE_LOADING";
export const INVREL_FETCH_DATA_SUCCESS = "INVREL_FETCH_DATA_SUCCESS";

export const GALLARY_HAVE_ERROR = "GALLARY_HAVE_ERROR";
export const GALLARY_ARE_LOADING = "GALLARY_ARE_LOADING";
export const GALLARY_FETCH_DATA_SUCCESS = "GALLARY_FETCH_DATA_SUCCESS";

export const GALLARY_INNER_HAVE_ERROR = "GALLARY_INNER_HAVE_ERROR";
export const GALLARY_INNER_ARE_LOADING = "GALLARY_INNER_ARE_LOADING";
export const GALLARY_INNER_FETCH_DATA_SUCCESS =
  "GALLARY_INNER_FETCH_DATA_SUCCESS";

export const SETTING_HAVE_ERROR = "SETTING_HAVE_ERROR";
export const SETTING_ARE_LOADING = "SETTING_ARE_LOADING";
export const SETTING_FETCH_DATA_SUCCESS = "SETTING_FETCH_DATA_SUCCESS";

export const HOMESECONDARY_HAVE_ERROR = "HOMESECONDARY_HAVE_ERROR";
export const HOMESECONDARY_ARE_LOADING = "HOMESECONDARY_ARE_LOADING";
export const HOMESECONDARY_FETCH_DATA_SUCCESS =
  "HOMESECONDARY_FETCH_DATA_SUCCESS";

export const WEBSTORY_HAVE_ERROR = "WEBSTORY_HAVE_ERROR";
export const WEBSTORY_ARE_LOADING = "WEBSTORY_ARE_LOADING";
export const WEBSTORY_FETCH_DATA_SUCCESS = "WEBSTORY_FETCH_DATA_SUCCESS";

export const WEBSTORYBYID_HAVE_ERROR = "WEBSTORYBYID_HAVE_ERROR";
export const WEBSTORYBYID_ARE_LOADING = "WEBSTORYBYID_ARE_LOADING";
export const WEBSTORYBYID_FETCH_DATA_SUCCESS =
  "WEBSTORYBYID_FETCH_DATA_SUCCESS";

export const SEARCH_TAG_HAVE_ERROR = "SEARCH_TAG_HAVE_ERROR";
export const SEARCH_TAG_ARE_LOADING = "SEARCH_TAG_ARE_LOADING";
export const SEARCH_TAG_FETCH_DATA_SUCCESS = "SEARCH_TAG_FETCH_DATA_SUCCESS";

export const HOMEPRIMARY_HAVE_ERROR = "HOMEPRIMARY_HAVE_ERROR";
export const HOMEPRIMARY_ARE_LOADING = "HOMEPRIMARY_ARE_LOADING";
export const HOMEPRIMARY_FETCH_DATA_SUCCESS = "HOMEPRIMARY_FETCH_DATA_SUCCESS";

export const GET_POLL_HAVE_ERROR = "GET_POLL_HAVE_ERROR";
export const GET_POLL_ARE_LOADING = "GET_POLL_ARE_LOADING";
export const GET_POLL_FETCH_DATA_SUCCESS = "GET_POLL_FETCH_DATA_SUCCESS";
export const STATE_HAVE_ERROR = "STATE_HAVE_ERROR";
export const STATE_ARE_LOADING = "STATE_ARE_LOADING";
export const STATE_FETCH_DATA_SUCCESS = "STATE_FETCH_DATA_SUCCESS";

export const CITIES_LIST_HAVE_ERROR = "CITIES_LIST_HAVE_ERROR";
export const CITIES_LIST_ARE_LOADING = "CITIES_LIST_ARE_LOADING";
export const CITIES_LIST_FETCH_DATA_SUCCESS = "CITIES_LIST_FETCH_DATA_SUCCESS";

export const CONSTITUENCY_LIST_HAVE_ERROR = "CONSTITUENCY_LIST_HAVE_ERROR";
export const CONSTITUENCY_LIST_ARE_LOADING = "CONSTITUENCY_LIST_ARE_LOADING";
export const CONSTITUENCY_LIST_FETCH_DATA_SUCCESS = "CONSTITUENCY_LIST_FETCH_DATA_SUCCESS";

export const ELE_RESULT_LIST_HAVE_ERROR = "ELE_RESULT_LIST_HAVE_ERROR";
export const ELE_RESULT_LIST_ARE_LOADING = "ELE_RESULT_LIST_ARE_LOADING";
export const ELE_RESULT_LIST_FETCH_DATA_SUCCESS = "ELE_RESULT_LIST_FETCH_DATA_SUCCESS";

export const ELE_STATE_SUMMEARY_HAVE_ERROR = "ELE_STATE_SUMMEARY_HAVE_ERROR";
export const ELE_STATE_SUMMEARY_ARE_LOADING = "ELE_STATE_SUMMEARY_ARE_LOADING";
export const ELE_STATE_SUMMEARY_FETCH_DATA_SUCCESS = "ELE_STATE_SUMMEARY_FETCH_DATA_SUCCESS";

export const HOMEPAGEWEBSTORY_HAVE_ERROR = "HOMEPAGEWEBSTORY_HAVE_ERROR";
export const HOMEPAGEWEBSTORY_ARE_LOADING = "HOMEPAGEWEBSTORY_ARE_LOADING";
export const HOMEPAGEWEBSTORY_FETCH_DATA_SUCCESS =
  "HOMEPAGEWEBSTORY_FETCH_DATA_SUCCESS";

export const VERIFYPAYMENT_HAVE_ERROR = "VERIFYPAYMENT_HAVE_ERROR";
export const VERIFYPAYMENT_ARE_LOADING = "VERIFYPAYMENT_ARE_LOADING";
export const VERIFYPAYMENT_FETCH_DATA_SUCCESS =
  "VERIFYPAYMENT_FETCH_DATA_SUCCESS";

export const GETEVENTS_HAVE_ERROR = "GETEVENTS_HAVE_ERROR";
export const GETEVENTS_ARE_LOADING = "GETEVENTS_ARE_LOADING";
export const GETEVENTS_FETCH_DATA_SUCCESS = "GETEVENTS_FETCH_DATA_SUCCESS";

export const CREATEORDERFORPAYMENT_HAVE_ERROR =
  "CREATEORDERFORPAYMENT_HAVE_ERROR";
export const CREATEORDERFORPAYMENT_ARE_LOADING =
  "CREATEORDERFORPAYMENT_ARE_LOADING";
export const CREATEORDERFORPAYMENT_FETCH_DATA_SUCCESS =
  "CREATEORDERFORPAYMENT_FETCH_DATA_SUCCESS";

export const GETEVENTBYID_HAVE_ERROR = "GETEVENTBYID_HAVE_ERROR";
export const GETEVENTBYID_ARE_LOADING = "GETEVENTBYID_ARE_LOADING";
export const GETEVENTBYID_FETCH_DATA_SUCCESS =
  "GETEVENTBYID_FETCH_DATA_SUCCESS";

export const submiteventform_HAVE_ERROR = "submiteventform_HAVE_ERROR";
export const submiteventform_ARE_LOADING = "submiteventform_ARE_LOADING";
export const submiteventform_FETCH_DATA_SUCCESS =
  "submiteventform_FETCH_DATA_SUCCESS";

export const GETEVENTFORM_HAVE_ERROR = "GETEVENTFORM_HAVE_ERROR";
export const GETEVENTSFORM_ARE_LOADING = "GETEVENTSFORM_ARE_LOADING";
export const GETEVENTSFORM_FETCH_DATA_SUCCESS =
  "GETEVENTSFORM_FETCH_DATA_SUCCESS";

export const GETBANNER_HAVE_ERROR = "GETBANNER_HAVE_ERROR";
export const GETBANNER_ARE_LOADING = "GETBANNER_ARE_LOADING";
export const GETBANNER_FETCH_DATA_SUCCESS = "GETBANNER_FETCH_DATA_SUCCESS";

export const POST_HAVE_ERROR = "POST_HAVE_ERROR";
export const POST_ARE_LOADING = "POST_ARE_LOADING";
export const POST_FETCH_DATA_SUCCESS = "POST_FETCH_DATA_SUCCESS";

export const POLL_VOTE_HAVE_ERROR = "POLL_VOTE_HAVE_ERROR";
export const POLL_VOTE_ARE_LOADING = "POLL_VOTE_ARE_LOADING";
export const POLL_VOTE_FETCH_DATA_SUCCESS = "POLL_VOTE_FETCH_DATA_SUCCESS";

export const POSTMORE_HAVE_ERROR = "POSTMORE_HAVE_ERROR";
export const POSTMORE_ARE_LOADING = "POSTMORE_ARE_LOADING";
export const POSTMORE_FETCH_DATA_SUCCESS = "POSTMORE_FETCH_DATA_SUCCESS";

export const AllViewCount_HAVE_ERROR = "AllViewCount_HAVE_ERROR";
export const AllViewCount_ARE_LOADING = "AllViewCount_ARE_LOADING";
export const AllViewCount_FETCH_DATA_SUCCESS =
  "AllViewCount_FETCH_DATA_SUCCESS";

export const IncrementPostViews_HAVE_ERROR = "IncrementPostViews_HAVE_ERROR";
export const IncrementPostViews_ARE_LOADING = "IncrementPostViews_ARE_LOADING";
export const IncrementPostViews_FETCH_DATA_SUCCESS =
  "IncrementPostViews_FETCH_DATA_SUCCESS";
export const IncrementWebStoryViews_HAVE_ERROR =
  "IncrementWebStoryViews_HAVE_ERROR";
export const IncrementWebStoryViews_ARE_LOADING =
  "IncrementWebStoryViews_ARE_LOADING";
export const IncrementWebStoryViews_FETCH_DATA_SUCCESS =
  "IncrementPostViews_FETCH_DATA_SUCCESS";

export const VIDEOINNER_HAVE_ERROR = "VIDEOINNER_HAVE_ERROR";
export const VIDEOINNER_ARE_LOADING = "VIDEOINNER_ARE_LOADING";
export const VIDEOINNER_FETCH_DATA_SUCCESS = "VIDEOINNER_FETCH_DATA_SUCCESS";

export const CATEGORY_HAVE_ERROR = "CATEGORY_HAVE_ERROR";
export const CATEGORY_ARE_LOADING = "CATEGORY_ARE_LOADING";
export const CATEGORY_FETCH_DATA_SUCCESS = "CATEGORY_FETCH_DATA_SUCCESS";

export const CATEGORYMULTI_HAVE_ERROR = "CATEGORYMULTI_HAVE_ERROR";
export const CATEGORYMULTI_ARE_LOADING = "CATEGORYMULTI_ARE_LOADING";
export const CATEGORYMULTI_FETCH_DATA_SUCCESS = "CATEGORYMULTI_FETCH_DATA_SUCCESS";

export const ENTERTAINMENT_HAVE_ERROR = "ENTERTAINMENT_HAVE_ERROR";
export const ENTERTAINMENT_ARE_LOADING = "ENTERTAINMENT_ARE_LOADING";
export const ENTERTAINMENT_FETCH_DATA_SUCCESS =
  "ENTERTAINMENT_FETCH_DATA_SUCCESS";

export const CATEGORYASTRO_HAVE_ERROR = "CATEGORYASTRO_HAVE_ERROR";
export const CATEGORYASTRO_ARE_LOADING = "CATEGORYASTRO_ARE_LOADING";
export const CATEGORYASTRO_FETCH_DATA_SUCCESS =
  "CATEGORYASTRO_FETCH_DATA_SUCCESS";

export const GUJARATSAMAGRACITY_HAVE_ERROR = "GUJARATSAMAGRA_HAVE_ERROR";
export const GUJARATSAMAGRACITY_ARE_LOADING = "GUJARATSAMAGRA_ARE_LOADING";
export const GUJARATSAMAGRACITY_FETCH_DATA_SUCCESS =
  "GUJARATSAMAGRA_FETCH_DATA_SUCCESS";

export const VIDEO_HAVE_ERROR = "VIDEO_HAVE_ERROR";
export const VIDEO_ARE_LOADING = "VIDEO_ARE_LOADING";
export const VIDEO_FETCH_DATA_SUCCESS = "VIDEO_FETCH_DATA_SUCCESS";

export const LOGING_HAVE_ERROR = "LOGING_HAVE_ERROR";
export const LOGING_ARE_LOADING = "LOGING_ARE_LOADING";
export const LOGING_FETCH_DATA_SUCCESS = "LOGING_FETCH_DATA_SUCCESS";

export const CITY_HAVE_ERROR = "CITY_HAVE_ERROR";
export const CITY_ARE_LOADING = "CITY_ARE_LOADING";
export const CITY_FETCH_DATA_SUCCESS = "CITY_FETCH_DATA_SUCCESS";

export const CITY_RESULT_HAVE_ERROR = "CITY_RESULT_HAVE_ERROR";
export const CITY_RESULT_ARE_LOADING = "CITY_RESULT_ARE_LOADING";
export const CITY_RESULT_FETCH_DATA_SUCCESS = "CITY_RESULT_FETCH_DATA_SUCCESS";

export const TITHI_HAVE_ERROR = "TITHI_HAVE_ERROR";
export const TITHI_ARE_LOADING = "TITHI_ARE_LOADING";
export const TITHI_FETCH_DATA_SUCCESS = "TITHI_FETCH_DATA_SUCCESS";

export const CHILDMENU_HAVE_ERROR = "CHILDMENU_HAVE_ERROR";
export const CHILDMENU_ARE_LOADING = "CHILDMENU_ARE_LOADING";
export const CHILDMENU_FETCH_DATA_SUCCESS = "CHILDMENU_FETCH_DATA_SUCCESS";

export const HOROSCOPE_HAVE_ERROR = "HOROSCOPE_HAVE_ERROR";
export const HOROSCOPE_ARE_LOADING = "HOROSCOPE_ARE_LOADING";
export const HOROSCOPE_FETCH_DATA_SUCCESS = "HOROSCOPE_FETCH_DATA_SUCCESS";

export const HOROSCOPE_DETAIL_HAVE_ERROR = "HOROSCOPE_DETAIL_HAVE_ERROR";
export const HOROSCOPE_DETAIL_ARE_LOADING = "HOROSCOPE_DETAIL_ARE_LOADING";
export const HOROSCOPE_DETAIL_FETCH_DATA_SUCCESS =
  "HOROSCOPE_DETAIL_FETCH_DATA_SUCCESS";

export const WIDGET_HAVE_ERROR = "WIDGET_HAVE_ERROR";
export const WIDGET_ARE_LOADING = "WIDGET_ARE_LOADING";
export const WIDGET_FETCH_DATA_SUCCESS = "WIDGET_FETCH_DATA_SUCCESS";

export const SEARCH_RESULT_HAVE_ERROR = "SEARCH_RESULT_HAVE_ERROR";
export const SEARCH_RESULT_ARE_LOADING = "SEARCH_RESULT_ARE_LOADING";
export const SEARCH_RESULT_FETCH_DATA_SUCCESS =
  "SEARCH_RESULT_FETCH_DATA_SUCCESS";

export const EPAPER_CATEGORY_HAVE_ERROR = "EPAPER_CATEGORY_HAVE_ERROR";
export const EPAPER_CATEGORY_ARE_LOADING = "EPAPER_CATEGORY_ARE_LOADING";
export const EPAPER_CATEGORY_FETCH_DATA_SUCCESS =
  "EPAPER_CATEGORY_FETCH_DATA_SUCCESS";

export const EPAPER_DOWNLOAD_PDF_HAVE_ERROR = "EPAPER_DOWNLOAD_PDF_HAVE_ERROR";
export const EPAPER_DOWNLOAD_PDF_ARE_LOADING = "EPAPER_DOWNLOAD_PDF_ARE_LOADING";
export const EPAPER_DOWNLOAD_PDF_FETCH_DATA_SUCCESS =
  "EPAPER_DOWNLOAD_PDF_FETCH_DATA_SUCCESS";

export const EPAPER_MENU_HAVE_ERROR = "EPAPER_MENU_HAVE_ERROR";
export const EPAPER_MENU_ARE_LOADING = "EPAPER_MENU_ARE_LOADING";
export const EPAPER_MENU_FETCH_DATA_SUCCESS = "EPAPER_MENU_FETCH_DATA_SUCCESS";

export const INPUT_VALUE_HAVE_ERROR = "INPUT_VALUE_HAVE_ERROR";
export const INPUT_VALUE_ARE_LOADING = "INPUT_VALUE_ARE_LOADING";
export const INPUT_VALUE_FETCH_DATA_SUCCESS = "INPUT_VALUE_FETCH_DATA_SUCCESS";

export const EPAPERIMAGE_HAVE_ERROR = "EPAPERIMAGE_HAVE_ERROR";
export const EPAPERIMAGE_ARE_LOADING = "EPAPERIMAGE_ARE_LOADING";
export const EPAPERIMAGE_FETCH_DATA_SUCCESS = "EPAPERIMAGE_FETCH_DATA_SUCCESS";

export const COMMENT_HAVE_ERROR = "COMMENT_HAVE_ERROR";
export const COMMENT_ARE_LOADING = "COMMENT_ARE_LOADING";
export const COMMENT_FETCH_DATA_SUCCESS = "COMMENT_FETCH_DATA_SUCCESS";

export const VIDEOCATEGORY_HAVE_ERROR = "VIDEOCATEGORY_HAVE_ERROR";
export const VIDEOCATEGORY_ARE_LOADING = "VIDEOCATEGORY_ARE_LOADING";
export const VIDEOCATEGORY_FETCH_DATA_SUCCESS =
  "VIDEOCATEGORY_FETCH_DATA_SUCCESS";

export const SPORTSCORE_HAVE_ERROR = "SPORTSCORE_HAVE_ERROR";
export const SPORTSCORE_ARE_LOADING = "SPORTSCORE_ARE_LOADING";
export const SPORTSCORE_FETCH_DATA_SUCCESS = "SPORTSCORE_FETCH_DATA_SUCCESS";

export const MARQUEE_HAVE_ERROR = "MARQUEE_HAVE_ERROR";
export const MARQUEE_ARE_LOADING = "MARQUEE_ARE_LOADING";
export const MARQUEE_FETCH_DATA_SUCCESS = "MARQUEE_FETCH_DATA_SUCCESS";

// for search module 
export const SEARCH_CATEGORY_RESULT_HAVE_ERROR = "SEARCH_CATEGORY_RESULT_HAVE_ERROR";
export const SEARCH_CATEGORY_RESULT_ARE_LOADING = "SEARCH_CATEGORY_RESULT_ARE_LOADING";
export const SEARCH_CATEGORY_RESULT_FETCH_DATA_SUCCESS = "SEARCH_CATEGORY_RESULT_FETCH_DATA_SUCCESS";
